import { useLocalStorage } from "@mantine/hooks"

// Device-local "demo mode" for the Nexus sidebar. ON (default) shows every screen with its
// "Demo" tag; OFF hides all not-yet-live (demo) screens for a clean live-only nav. Per-device
// on purpose — you want it OFF on the presentation laptop and ON on the dev box at the same
// time, and default-ON fails safe (a fresh device shows everything). Mantine useLocalStorage
// keeps every instance in this tab in sync, so shell / top bar / settings share one source.
export const DEMO_MODE_KEY = "civala.demoMode.nexus"

export const useDemoMode = () =>
  useLocalStorage<boolean>({
    key: DEMO_MODE_KEY,
    defaultValue: true,
    getInitialValueInEffect: false,
  })
